import React,{Component} from 'react'

import {
  Typography,
} from 'material-ui'

import Fade from 'material-ui/transitions/Fade'

import '../styles/SectionTitle.css'

// const style = {
//   title:{
//     fontSize: '18px',
//     margin: '27px 0 5px 0',
//     fontWeight: '400',
//   }
// }

export default class SkeletonSectionTitle extends Component{
  render(){
    // const {title} = this.props;
    return(
      <Fade in={true}>
        <Typography className='cardWidth titleSkeleton title skeletonCardTitle' type='caption' >
           ~
        </Typography>
      </Fade>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SkeletonSectionTitle.js